import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

/**
 * @method apiGetMainConfig
 */
export default {
    /**
     * Return main config
     */
    apiGetImgConfig: function() {
        var url = ConfigManager.getBlobUrl() + `/config/bbl_redemption/mission/config.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    apiGetMissionDetail: function(language) {
        var url = ConfigManager.getBlobUrl() + `/config/bbl_redemption/mission/terms/${language}`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    apiCheckIn: function() {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + `/checkin`;
        return BzbsApi.connectBzbsPut(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },
    apiCheckStatusCheckIn: function() {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + `/checkin/status`;
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res;
        }));
    },
    getBadge: function (group) {
        var token = Account.getToken();
        var url = ConfigManager.getApiUrl() + "/profile/me/badges";
        // var params = {
        //     "group": "login"
        // }
        var params = {};

        if(group){
            params.group = group;
        }
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    /**
     * Return mission blob config
     */
    apiGetMissionConfig: function() {
        var appId = ConfigManager.getAppId();
        var url = ConfigManager.getBlobUrl() + `/webconfig/${appId}/mission_config`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    getMissionDetailConfig: function() {
        var appId = ConfigManager.getAppId();
        var url = ConfigManager.getBlobUrl() + `/webconfig/${appId}/mission_detail`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
    getMissionGamePuzzleDetailConfig: function() {
        var appId = ConfigManager.getAppId();
        var url = ConfigManager.getBlobUrl() + `/webconfig/${appId}/mission_detail_puzzle`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },
    getMissionGameMatchDetailConfig: function() {
        var appId = ConfigManager.getAppId();
        var url = ConfigManager.getBlobUrl() + `/webconfig/${appId}/mission_detail_match.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    //#region game
    getGameConfig: function(){
        var token = Account.getToken();
        var url = ConfigManager.getApiModuleUrl() + "/game";

        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },
    //#endregion game

    //#region mission transaction
    getMissionTrasaction: function(){
        var token = Account.getToken();
        var url = ConfigManager.getApiModuleUrl() + "/mission";

        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },
    //#endregion game

    //#region transaction
    missionConfirm: function (data) {
        const token = Account.getToken();
        const params = {
            missionId: data.id,
            campaignId: data.campaign,
            itemNumber: data.itemNumber,
        };

        const url = ConfigManager.getApiModuleUrl() + '/mission/confirm';
        return BzbsApi.connectBzbsPost(url, token, params, null, null).pipe(map((res) => {
            return res.data;
        }));
    },
    //#endregion transaction

    apiGetFriendConfig: function() {
        var appId = ConfigManager.getAppId();
        var url = ConfigManager.getBlobUrl() + `/webconfig/${appId}/fgf.json`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

};
